/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLayoutCards = createReactComponent("layout-cards", "IconLayoutCards", [
  [
    "path",
    {
      d: "M4 4m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z",
      key: "svg-0"
    }
  ],
  [
    "path",
    {
      d: "M14 4m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z",
      key: "svg-1"
    }
  ]
]);

export { IconLayoutCards as default };
//# sourceMappingURL=IconLayoutCards.js.map
